import {useState,useEffect} from 'react';

const useScrollBarPosition = () => {
    const [scrollPosition, setScrollPosition] = useState(null);


    useEffect(() => {
        const handleScroll = (e) => {
            const {scrollTop, scrollHeight, clientHeight} = e.target.documentElement;
            setScrollPosition(scrollTop / (scrollHeight - clientHeight) * 100);
        }

        window.addEventListener('scroll', handleScroll);
        return () => {window.removeEventListener('scroll', handleScroll);}
    });

    return scrollPosition;
}


export default useScrollBarPosition;